import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useApp();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-sm w-full text-center"
      >
        <div className="w-20 h-20 rounded-full bg-destructive/15 grid place-items-center mx-auto animate-pop-in">
          <XCircle className="w-11 h-11 text-destructive" />
        </div>
        <h1 className="text-2xl font-black mt-5">{t.paymentCancelled}</h1>
        <p className="text-muted-foreground mt-2">{t.paymentCancelledDesc}</p>
        <Button
          data-testid="payment-back-to-wallet"
          onClick={() => navigate("/", { replace: true })}
          className="w-full h-[52px] rounded-2xl text-base font-bold mt-8"
        >
          {t.backToWallet}
        </Button>
      </motion.div>
    </div>
  );
}
